<template>
  <v-dialog v-model="show" persistent width="600">
    <v-card>
      <v-card-title class="text-h5">
        <v-btn icon @click="show = false" class="ml-auto" color="red">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="mt-">
        <img :src="image" alt="Image Preview" class="preview-image" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["visible", "image"],
  data() {
    return {
      modal1: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {},
};
</script>

<style scoped>
.preview-image {
  width: 100%;
  height: auto;
  max-height: 500px;
  object-fit: cover;
}
</style>
